import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AppService } from '../../../../../../../../app.service';
import { AuthService } from '../../../../../../../../core/auth/auth.service';
import { DialogButton, DialogData } from '../../../../../../../../core/services/dialog.service';
import { ClaimI} from '../../../../../../interfaces/claim.interface';
import {CustomerDomainI} from '../../../../../../interfaces/customer-domain.interface';

@Component({
  selector: 'app-domain-edit',
  templateUrl: './domain-edit.component.html',
  styleUrls: ['./domain-edit.component.scss']
})
export class DomainEditComponent implements OnInit {


  @Input() domain: CustomerDomainI;
  @Input() domainFormGroup: FormGroup;
  @Output() domainRemove = new EventEmitter<CustomerDomainI>();

  claims: ClaimI[] = [];
  constructor(public app: AppService, private auth: AuthService) { }

  ngOnInit(): void {
    this.app.getClaims().then(claims => this.claims = claims);
  }

  submitDomain() {
    if (this.domainFormGroup.valid) {
      const domain = Object.assign({}, this.domain) as CustomerDomainI;
      const domainValues = this.domainFormGroup.value as { [key: string]: string | boolean };
      for (let k in domainValues) {

        if (domain.hasOwnProperty(k) && domainValues.hasOwnProperty(k)) {
          switch (k) {
            case 'start':
              domain[k] = this.app.dateFormatToDB(domainValues[k]);
              break;
            case 'expiry':
              domain[k] = this.app.dateFormatToDB(domainValues[k]);
              break;
            case 'renewal':
              domain[k] = domainValues[k] ? '1' : '0';
              break;
            case 'domains':
              let val = (domainValues[k] as string).trim();
              domain[k] = val.split(',').map(d => d.trim());
              break;
            default:
              domain[k] = domainValues[k];
              break;
          }
        }
      }

      if(domain.id === '0') {
        this.createCustomer2Domain(domain);
      } else {
        this.updateCustomer2Domain(domain);
      }
    } else {
      console.log('form invalid');
    }
  }

  createCustomer2Domain(domain: CustomerDomainI) {
    this.app.customerDomainCreate(domain, this.auth.user.id).then(res => {
      if (res) {
        this.domain.id = res.id;
        (this.domainFormGroup.parent as FormGroup).addControl(res.id, this.domainFormGroup);
        (this.domainFormGroup.parent as FormGroup).removeControl(domain.id);
        this.app.toast.open('Der Zugang für Mitarbeiter wurde erstellt.');
      }
    }).catch(err => {
      this.app.toast.open('Unbekannter Fehler', null, {
        panelClass: 'warn'
      });
    });
  }

  updateCustomer2Domain(domain: CustomerDomainI) {
    this.app.customerDomainUpdate(domain, this.auth.user.id).then(res => {
      if (res) {
        this.domain = domain;
        this.app.toast.open('Der Zugang für Mitarbeiter wurde aktualisiert');
      }
    }).catch(err => {
      this.app.toast.open('Unbekannter Fehler', null, {
        panelClass: 'warn'
      });
    });
  }

  deleteDomainAlert() {
    const y: DialogButton = {
      name: 'Ja',
      color: 'warn',
      handler: () => {
        this.deleteDomain();
        dialRef.close();
      }
    };

    const n: DialogButton = {
      name: 'Abbrechen',
      handler: () => {
        dialRef.close();
      }
    };

    const data: DialogData = {
      subTitle: 'Wollen Sie den Zugang löschen?',
      buttons: [y, n]
    };

    const dialRef = this.app.dialog.alert(data, {width: '50vh'});
  }

  deleteDomain() {
    if(this.domain.id !== '0') {
      this.app.customerDomainDelete(this.domain.id).then(res => {
        if (res) {
          this.domainRemove.emit(this.domain);
          this.app.toast.open('Der Zugang für Mitarbeiter wurde gelöscht');
        }
      }).catch(err => {
        this.app.toast.open('Unbekannter Fehler', null, {
          panelClass: 'warn'
        });
      });
    } else {
      this.domainRemove.emit(this.domain);
    }
  }
}
